APP.accountForm = function () {
  let form = $('#accountForm', APP.context)
  $('input[type="text"],input[type="number"]', form).on('input', function () {
    APP.validAccountForm()
  })
  $('select', form).on('change', function () {
    APP.validAccountForm()
  })
}

APP.validAccountForm = function () {
  let form = $('#accountForm')
  let count_required_elements = APP.countElementRequired()
  let commonPer = 100 / count_required_elements
  let commonValue = APP.getProgressBarPercentage(commonPer)
  commonValue = commonValue > 99 ? 100 : commonValue
  if (count_required_elements == 0 ) {
    commonValue = 100;
  }
  APP.time_line(commonValue)
  if (commonValue === 100) {
    $('.form-submit', form).attr('disabled', false)
  } else {
    $('.form-submit', form).attr('disabled', true)
  }
}

APP.time_line = function (commonValue) {
  if (commonValue == 100) {
    $('.time__line').addClass('full')
  } else {
    $('.time__line').removeClass('full')
  }
  $('#commonPer').css({ width: commonValue + '%' })
}

APP.countElementRequired = function () {
  let count = 0
  let form = $('#accountForm', APP.context)
  $('input[type="text"],input[type="number"], select', form).each(function () {
    if ($(this).hasClass('required')) {
      count++
    }
  })
  return count
}

APP.getProgressBarPercentage = function (commonPer) {
  var commonValue = 0
  let form = $('#accountForm')
  $('input[type="text"]', form).each(function () {
    if ($(this).is('.datepicker') && $(this).val() !='') {
      if (APP.isValidDate($(this).val())) {
        commonValue += commonPer
        $(this).closest('.form-item').removeClass('form-error')
      } else {
        $(this).closest('.form-item').addClass('form-error')
      }
    }
    else if ($(this).is('[name="email"]') && $(this).val() !='') {
      let email_regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if (email_regex.test($(this).val())) {
        commonValue += commonPer
        $(this).closest('.form-item').removeClass('form-error')
      } else {
        $(this).closest('.form-item').addClass('form-error')
      }
    } else {
      if ($(this).hasClass('required')) {
        if ($(this).val() != '') {
          commonValue += commonPer
          $(this).closest('.form-item').removeClass('form-error')
        }
        else {
          $(this).closest('.form-item').addClass('form-error')
        }
      } else {
        $(this).closest('.form-item').removeClass('form-error')
      }
    }
  })
  $('input[type="number"]', form).each(function () {
    if ($(this).hasClass('required')) {
      if ($(this).val() != '' && !isNaN($(this).val())) {
        commonValue += commonPer
        $(this).closest('.form-item').removeClass('form-error')
      } else {
        $(this).closest('.form-item').addClass('form-error')
      }
    }
  })
  $('select', form).each(function () {
    if ($(this).hasClass('required')) {
      if ($(this).val() != '') {
        commonValue += commonPer
        $(this).closest('.form-item').removeClass('form-error')
      } else {
        $(this).closest('.form-item').addClass('form-error')
      }
    }
  })
  return commonValue
}
APP.isValidDate = function (day) {
    day = day.split('/');
    if (day.length != 3) {
      return false;
    }
    //In javascipt  month will be start from 0 to 11 so the input date must be month = input month - 1
    let d = new Date(day[2], day[1] - 1 , day[0]);
    let current = new Date();
    if (d.getTime() <= current.getTime() && d.getFullYear() == day[2] && d.getMonth() + 1  == day[1] && d.getDate() == day[0]) {
      return true;
    }
    return false;
}
